import { useT } from "@transifex/react";
import type { ReactNode } from "react";
import { useState } from "react";
import PhaseSixIcon from "../../basic/phaseSixIcon/PhaseSixIcon";

interface OlderActivitiesSectionProps {
    children?: ReactNode;
}

export const OlderActivitiesSection = (props: OlderActivitiesSectionProps) => {
    const t = useT();
    const t_olderThan3Weeks = t("Older than 3 weeks", {
        _tags: "ClassMemberDashboard, OlderActivitiesSection",
    });
    const t_hide = t("Hide", { _tags: "ClassMemberDashboard, OlderActivitiesSection" });
    const t_show = t("Show", { _tags: "ClassMemberDashboard, OlderActivitiesSection" });

    const [isExpanded, setIsExpanded] = useState(true);

    const handleToggle = () => setIsExpanded((prev) => !prev);

    return (
        <section className="flex flex-col gap-s w-full">
            <button
                type="button"
                onClick={handleToggle}
                className="flex items-center justify-between w-full text-left cursor-pointer"
                aria-expanded={isExpanded}
            >
                <h2 className="text-xl text-p6-grey-dark font-normal">{t_olderThan3Weeks}</h2>
                <div className="flex items-center gap-xs text-l text-p6-grey-dark">
                    <span>{isExpanded ? t_hide : t_show}</span>
                    <PhaseSixIcon
                        name="chevron-down"
                        className={`text-xl transition-transform ${isExpanded ? "rotate-180" : ""}`}
                        aria-hidden="true"
                    />
                </div>
            </button>
            {isExpanded && props.children}
        </section>
    );
};
